import {
  GET_EXPORT_CATALOG,
  GET_EXPORT_CATALOG_SUCCESS,
  GET_EXPORT_CATALOG_ERROR,
} from '../../../constants/constantsRed';

export const getExportCatalogRed = (
  state: any = false,
  actions: any
) => {
  switch (actions.type) {
    case GET_EXPORT_CATALOG:
      return {
        ...state,
        loading: true,
      };
    case GET_EXPORT_CATALOG_SUCCESS:
      return {
        data: null,
        loading: false,
        error: null,
      };
    case GET_EXPORT_CATALOG_ERROR:
      return {
        ...state,
        loading: false,
        error: null,
        data: actions.payload,
      };
    default:
      return state;
  }
};
